import { getAlternativeIdentifiers } from "../util";
/**
 * Modelo de um objeto de alternativas
 * {
 *  "id_grupo": "1111-1111-1111"
 *  "id_alternativa": 10,
 *  "enunciado_alternativa": "ZONA_URBANA",
 *  "id_pergunta": 5,
 *  "id_pesquisa": 3,
 *  "titulo_pesquisa": "Pesquisa teste "
 * }
 */

/**
 * @param {array} alternatives Array de alternativas.
 * @returns - Array de alternativas adequado para ser utilizado no componente GenericCollapsibleList.
 */
export const alternativesToGenericModel = function(alternatives = []) {
  return alternatives.map(
    ({ id_grupo, id_pesquisa, id_pergunta, id_alternativa, enunciado_alternativa, titulo_pesquisa, ...rest }) => ({
      id: `${id_grupo}_${id_pesquisa}_${id_pergunta}_${id_alternativa}`,
      mainTitle: enunciado_alternativa,
      tagTitle: titulo_pesquisa,
      ...rest
    })
  );
};

/**
 * 
 * @param {array} alternatives array de alternativas. 
 * @returns Array de alternativas adequado para ser manipulado pelo array interno no StepThree
 */
export const genericModalDataToAlternativeData = (alternatives = [] ) => alternatives.map( ({id, mainTitle, tagTitle}) => {
  const { groupId, surveyId, questionId, alternativeId } = getAlternativeIdentifiers(id);
  return {
    enunciado_alternativa: mainTitle,
    id_alternativa: alternativeId,
    id_grupo: groupId,
    id_pergunta: questionId,
    id_pesquisa: surveyId,
    titulo_pesquisa: tagTitle,
  }
});

/**
 * Mapeia uma lista de alternativas para um array com seus respectivos id's de pesquisa.
 * @param {array} alternativeList 
 * @returns {array<number>} Array com os ids relativos à pesquisa de cada alternativa.
 */
export const mapAlternativesToSurveyIdList = function(alternativeList = []) {
  return alternativeList.map(({ id }) => {
    const { surveyId } = getAlternativeIdentifiers(id);
    return surveyId;
  });
}